// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-Q":"Q_shp2-detail-Q__K4pDS"};